/* Aggregate Build Total only; selections, cart payloads and Shopify prices are external. */
(function () {
  'use strict';
  const storefront = window.BSStorefront = window.BSStorefront || {};
  if (storefront.ncrBuilderPricing) return;
  let unregisterLifecycle;

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined);
      } catch (err) { /* fallthrough */ }
    }
    const dollars = (Number(cents) / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function render(section) {
    const root = section.querySelector('.builder-rows');
    if (!root) return;
    const totalEl = section.querySelector('.builder-total-value');
    let total = 0;
    root.querySelectorAll('.builder-row').forEach(function(row) {
      const include = row.querySelector('.builder-include-input');
      if (!include || !include.checked) return;
      const active = row.querySelector('.builder-finish-btn.is-active');
      if (!active) return;
      // Preserve baseline availability and missing/malformed-data semantics.
      if (active.dataset.variantAvailable === 'false') return;
      total += Number(active.dataset.variantPrice || 0);
    });
    if (totalEl) {
      totalEl.textContent = formatMoney(total);
      totalEl.setAttribute('aria-busy', 'false');
    }
    return total;
  }

  function register() {
    document.removeEventListener('DOMContentLoaded', register);
    unregisterLifecycle = storefront.lifecycle.register('ncr-builder-pricing', '[data-bs-builder-selection]', function(section) {
      const onChange = () => render(section);
      section.addEventListener('bs:builder-selection-change', onChange);
      try {
        render(section);
      } catch (error) {
        section.removeEventListener('bs:builder-selection-change', onChange);
        throw error;
      }
      return function dispose() {
        section.removeEventListener('bs:builder-selection-change', onChange);
      };
    });
  }

  storefront.ncrBuilderPricing = {
    render: render,
    unregister: function () {
      document.removeEventListener('DOMContentLoaded', register);
      if (unregisterLifecycle) unregisterLifecycle();
    }
  };
  // Layout defers this asset after lifecycle and before selection. Late registration
  // also reads current DOM state, so notifications before mounting need no replay.
  if (storefront.lifecycle) register();
  else document.addEventListener('DOMContentLoaded', register, { once: true });
})();
